import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Box,
} from "@mui/material";

// Human-readable explanation for each skip reason returned by the
// delegateApprover endpoint.
const REASON_LABELS = {
  EXEC_CHEF_RAISED_CHEF_DELEGATION_BLOCKED:
    "Raised by an executive chef — the chef approver cannot be delegated on this request.",
  INCONSISTENT_REQUEST_STATE:
    "Request data is inconsistent, so it was left unchanged to avoid corrupting it.",
  REQUEST_NOT_FOUND: "Request could not be found.",
};

function reasonLabel(reason) {
  return REASON_LABELS[reason] ?? reason ?? "Skipped.";
}

/**
 * Shows the requests that were skipped during a delegate-approver action, along
 * with why each was skipped. Rendered only when there is at least one skipped
 * request.
 *
 * @param {boolean} open        whether the dialog is visible
 * @param {Function} onClose    close handler
 * @param {Array} skippedRows   [{ sampleRequestID, executiveChefEmail, email, reason }]
 */
export function SkippedRequestsModal({ open, onClose, skippedRows = [] }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { borderRadius: "20px" } }}
    >
      <DialogTitle>
        {skippedRows.length} request{skippedRows.length === 1 ? "" : "s"} skipped
      </DialogTitle>
      <DialogContent dividers>
        <Typography sx={{ mb: 2 }}>
          The approver was updated for the other selected requests. These
          requests were left unchanged:
        </Typography>
        <Box sx={{ overflowX: "auto" }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Sample Request ID</TableCell>
                <TableCell>Chef Email</TableCell>
                <TableCell>Executive Chef Email</TableCell>
                <TableCell>Reason</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {skippedRows.map((row) => (
                <TableRow key={row.sampleRequestID}>
                  <TableCell>{row.sampleRequestID}</TableCell>
                  <TableCell>{row.email ? row.email : "N/A"}</TableCell>
                  <TableCell>{row.executiveChefEmail ?? "N/A"}</TableCell>
                  <TableCell>{reasonLabel(row.reason)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" sx={{ borderRadius: "10px" }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
